import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';

import {ApplicationState} from '../../application-state/store';
import {CustomerAccountInvitationsActions} from '../store';
import {CustomerAccountInvitationsSelectors} from '../store/selectors';

@Injectable()
export class CustomerAccountInvitationsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadCustomerAccountInvitations().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCustomerAccountInvitations(): Observable<boolean> {

    return this.store.pipe(
      select(CustomerAccountInvitationsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CustomerAccountInvitationsActions.ReadCustomerAccountInvitations({page: 1}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
